export const FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST = 'FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST'
export const FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS = 'FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS'
export const FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED = 'FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED'
export const FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST = 'FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST'
export const FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS = 'FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS'
export const FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED = 'FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED'
